export const UPDATE_PRODUCT_CUSTOMISATION = 'UPDATE_PRODUCT_CUSTOMISATION';
export const REMOVE_PRODUCT_CUSTOMISATION = 'REMOVE_PRODUCT_CUSTOMISATION';

export const updateProductCustomisation = (productKey, customisation) => ({
  type: UPDATE_PRODUCT_CUSTOMISATION,
  productKey,
  customisation,
});

export const removeProductCustomisation = customisationKeys => ({
  type: REMOVE_PRODUCT_CUSTOMISATION,
  customisationKeys,
});



// WEBPACK FOOTER //
// ./src/client/js/store/actions/product.js